<template>
  <div>
    <div class="text-xl font-black py-2">6. Use of services continued</div>

    <div class="pt-2" v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
      <div class="text-lg font-black py-2">Guild product usage</div>
      <div>Below is a summary of your active products</div>
      <div class="my-8 pt-2">
        <div class="mb-4">
          <div class="py-2">
            <div class="flex w-full justify-center items-center text-lg font-black">
              <div class="flex-grow text-center py-2">Referrals</div>
              <div class="w-2/5 px-4 text-center pb-4">6 to 12 Months</div>
              <div class="w-2/5 px-4 text-center pb-4">Last 6 Months</div>
            </div>
            <div class="flex w-full justify-center items-center border-b">
              <div class="flex-grow py-2 w-1/5 mr-8 text-sm">Number of vendor referrals <span class="font-black">sent</span> over the last 12 months</div>
              <div class="w-2/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Sent</div>
                  <div class="text-xs p-2 bg-gray-200">{{ previous_sender_referral_sent }}</div>
                </div>
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Declined</div>
                  <div class="text-xs p-2 bg-gray-200">{{ previous_sender_referral_declined }}</div>
                </div>
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Accepted</div>
                  <div class="text-xs p-2 bg-gray-200">{{ previous_sender_referral_accepted }}</div>
                </div>
              </div>
              <div class="w-2/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Sent</div>
                  <div class="text-xs p-2 bg-gray-200">{{ current_sender_referral_sent }}</div>
                </div>
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Declined</div>
                  <div class="text-xs p-2 bg-gray-200">{{ current_sender_referral_declined }}</div>
                </div>
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Accepted</div>
                  <div class="text-xs p-2 bg-gray-200">{{ current_sender_referral_accepted }}</div>
                </div>
              </div>
            </div>
            <div class="flex w-full justify-center items-center my-2 border-b">
              <div class="flex-grow py-2 w-1/5 mr-8 text-sm">Number of vendor referrals <span class="font-black">received</span> over the last 12 months</div>
              <div class="w-2/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="mx-2 w-1/3">
                  <div class="text-xs text-center">Sent</div>
                  <div class="text-xs p-2 bg-gray-200">{{ previous_receiver_referral_sent }}</div>
                </div>
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Declined</div>
                  <div class="text-xs p-2 bg-gray-200">{{ previous_receiver_referral_declined }}</div>
                </div>
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Accepted</div>
                  <div class="text-xs p-2 bg-gray-200">{{ previous_receiver_referral_accepted }}</div>
                </div>
              </div>
              <div class="w-2/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Sent</div>
                  <div class="text-xs border p-2 bg-gray-200">{{ current_receiver_referral_sent }}</div>
                </div>
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Declined</div>
                  <div class="text-xs border p-2 bg-gray-200">{{ current_receiver_referral_declined }}</div>
                </div>
                <div class="mx-2 w-1/3">
                  <div class="text-xs">Accepted</div>
                  <div class="text-xs border p-2 bg-gray-200">{{ current_receiver_referral_accepted }}</div>
                </div>
              </div>
            </div>
            <div class="flex w-full justify-between bg-gray-300 my-4 py-4" v-if="review.scorecard_flag">
              <div class="flex-grow py-2 w-1/5 mr-8"></div>
              <div class="w-2/5 border-l px-4 mr-2 text-end pb-4 text-lg">
                {{ previous_referral_revenue | currency }}
              </div>
              <div class="w-2/5 border-l px-4 mr-2 text-center pb-4">
                <div class="flex">
                  <div class="text-lg mr-8">Potential Revenue: </div>
                  <div class="text-lg">{{ current_referral_revenue | currency }}</div>
                </div>
                <div class="text-xs  text-left">* Based on an average fee of £800 per sent referral & £2,000 per reveived referral</div>
              </div>
            </div>
          </div>
          <div class="py-2">
            <div class="flex w-full justify-center items-center text-lg font-black">
              <div class="flex-grow text-center py-2"></div>
              <div class="w-1/5 px-4 text-center pb-4">Previous</div>
              <div class="w-1/5 px-4 text-center pb-4">Current</div>
            </div>
            <div class="flex w-full justify-center items-center border-b">
              <div class="flex-grow py-2 w-1/5 mr-8 text-sm">
                <div class="py-2 text-lg font-black">Video Branding Tool</div>
                Number of videos created</div>
              <div class="w-1/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="text-xs p-2 bg-gray-200 w-full">{{question.previous_value && question.previous_value.branding_videos_generated && review.scorecard_flag ? question.previous_value.branding_videos_generated : '-' }}</div>
              </div>
              <div class="w-1/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="text-xs border p-2 bg-gray-200 w-full">{{question.result && question.result.branding_videos_generated && review.scorecard_flag ? question.result.branding_videos_generated : '-' }}</div>
              </div>
            </div>

            <div class="flex w-full justify-center items-center border-b">
              <div class="flex-grow py-2 w-1/5 mr-8 text-sm">
                <div class="py-2 text-lg font-black">Auto Prospecting Service (APS)</div>
                Card sent</div>
              <div class="w-1/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="text-xs p-2 bg-gray-200 w-full">{{question.previous_value && question.previous_value.aps_number && review.scorecard_flag ? question.previous_value.aps_number : '-' }}</div>
              </div>
              <div class="w-1/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="text-xs border p-2 bg-gray-200 w-full">{{question.result && question.result.aps_number && review.scorecard_flag ? question.result.aps_number : '-' }}</div>
              </div>
            </div>

            <div class="flex w-full justify-center items-center border-b">
              <div class="flex-grow py-2 w-1/5 mr-8 text-sm">
                <div class="py-2 text-lg font-black">Auto Direct Mail (20/20) Campaigns</div>
                Card sent</div>
              <div class="w-1/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="text-xs p-2 bg-gray-200 w-full">{{question.previous_value && question.previous_value.auto2020_orders_created && review.scorecard_flag ? question.previous_value.auto2020_orders_created : '-' }}</div>
              </div>
              <div class="w-1/5 border-l px-4 mr-2 text-center pb-4 flex">
                <div class="text-xs border p-2 bg-gray-200 w-full">{{question.result && question.result.auto2020_orders_created && review.scorecard_flag ? question.result.auto2020_orders_created : '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
import ReviewProductUsageComponent from '@/components/AnnualReview/ReviewProductUsageComponent'

export default {
  components: { ReviewQuestionComponent, ReviewProductUsageComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  },
  computed: {
    previous_referral_revenue () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let question = this.form.questions[this.page][this.sectionStart][0]
      let sellingRevenue = 0
      let buyingRevenue = 0
      let receiverSellingRevenue = 0
      let receiverBuyingRevenue = 0
      if (question.previous_value && question.previous_value.referrals_selling_accepted) {
        sellingRevenue = question.previous_value.referrals_selling_accepted * 800
      }
      if (question.previous_value && question.previous_value.referrals_buying_accepted) {
        buyingRevenue = question.previous_value.referrals_buying_accepted * 800
      }
      if (question.previous_value && question.previous_value.receiver_referrals_selling_accepted) {
        receiverSellingRevenue = question.previous_value.receiver_referrals_selling_accepted * 2000
      }
      if (question.previous_value && question.previous_value.receiver_referrals_buying_accepted) {
        receiverBuyingRevenue = question.previous_value.receiver_referrals_buying_accepted * 2000
      }
      return sellingRevenue + buyingRevenue + receiverSellingRevenue + receiverBuyingRevenue
    },
    current_referral_revenue () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let question = this.form.questions[this.page][this.sectionStart][0]
      let sellingRevenue = 0
      let buyingRevenue = 0
      let receiverSellingRevenue = 0
      let receiverBuyingRevenue = 0
      if (question.result && question.result.referrals_selling_accepted) {
        sellingRevenue = question.result.referrals_selling_accepted * 800
      }
      if (question.result && question.result.referrals_buying_accepted) {
        buyingRevenue = question.result.referrals_buying_accepted * 800
      }
      if (question.result && question.result.receiver_referrals_selling_accepted) {
        receiverSellingRevenue = question.result.receiver_referrals_selling_accepted * 2000
      }
      if (question.result && question.result.receiver_referrals_buying_accepted) {
        receiverBuyingRevenue = question.result.receiver_referrals_buying_accepted * 2000
      }
      return sellingRevenue + buyingRevenue + receiverSellingRevenue + receiverBuyingRevenue
    },
    previous_sender_referral_sent () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let senderSentNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.previous_value || (!question.previous_value.referrals_selling_sent && !question.previous_value.referrals_buying_sent)) {
        return 'N/A'
      }
      if (question.previous_value && question.previous_value.referrals_selling_sent) {
        senderSentNum += question.previous_value.referrals_selling_sent
      }
      if (question.previous_value && question.previous_value.referrals_buying_sent) {
        senderSentNum += question.previous_value.referrals_buying_sent
      }
      return senderSentNum
    },
    previous_sender_referral_declined () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let senderDeclinedNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.previous_value || (!question.previous_value.referrals_selling_closed && !question.previous_value.referrals_buying_closed)) {
        return 'N/A'
      }
      if (question.previous_value && question.previous_value.referrals_selling_closed) {
        senderDeclinedNum += question.previous_value.referrals_selling_closed
      }
      if (question.previous_value && question.previous_value.referrals_buying_closed) {
        senderDeclinedNum += question.previous_value.referrals_buying_closed
      }
      return senderDeclinedNum
    },
    previous_sender_referral_accepted () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let senderAcceptedNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.previous_value || (!question.previous_value.referrals_selling_accepted && !question.previous_value.referrals_buying_accepted)) {
        return 'N/A'
      }
      if (question.previous_value && question.previous_value.referrals_selling_accepted) {
        senderAcceptedNum += question.previous_value.referrals_selling_accepted
      }
      if (question.previous_value && question.previous_value.referrals_buying_accepted) {
        senderAcceptedNum += question.previous_value.referrals_buying_accepted
      }
      return senderAcceptedNum
    },
    current_sender_referral_sent () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let senderSentNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.result || (!question.result.referrals_selling_sent && !question.result.referrals_buying_sent)) {
        return 'N/A'
      }
      if (question.result && question.result.referrals_selling_sent) {
        senderSentNum += question.result.referrals_selling_sent
      }
      if (question.result && question.result.referrals_buying_sent) {
        senderSentNum += question.result.referrals_buying_sent
      }
      return senderSentNum
    },
    current_sender_referral_declined () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let senderDeclinedNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.result || (!question.result.referrals_selling_closed && !question.result.referrals_buying_closed)) {
        return 'N/A'
      }
      if (question.result && question.result.referrals_selling_closed) {
        senderDeclinedNum += question.result.referrals_selling_closed
      }
      if (question.result && question.result.referrals_buying_closed) {
        senderDeclinedNum += question.result.referrals_buying_closed
      }
      return senderDeclinedNum
    },
    current_sender_referral_accepted () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let senderAcceptedNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.result || (!question.result.referrals_selling_accepted && !question.result.referrals_buying_accepted)) {
        return 'N/A'
      }
      if (question.result && question.result.referrals_selling_accepted) {
        senderAcceptedNum += question.result.referrals_selling_accepted
      }
      if (question.result && question.result.referrals_buying_accepted) {
        senderAcceptedNum += question.result.referrals_buying_accepted
      }
      return senderAcceptedNum
    },

    previous_receiver_referral_sent () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let receiverSentNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.previous_value || (!question.previous_value.receiver_referrals_selling_sent && !question.previous_value.receiver_referrals_buying_sent)) {
        return 'N/A'
      }
      if (question.previous_value && question.previous_value.receiver_referrals_selling_sent) {
        receiverSentNum += question.previous_value.referrals_selling_sent
      }
      if (question.previous_value && question.previous_value.receiver_referrals_buying_sent) {
        receiverSentNum += question.previous_value.referrals_buying_sent
      }
      return receiverSentNum
    },
    previous_receiver_referral_declined () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let receiverDeclinedNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.previous_value || (!question.previous_value.receiver_referrals_selling_closed && !question.previous_value.receiver_referrals_buying_closed)) {
        return 'N/A'
      }
      if (question.previous_value && question.previous_value.receiver_referrals_selling_closed) {
        receiverDeclinedNum += question.previous_value.referrals_selling_closed
      }
      if (question.previous_value && question.previous_value.receiver_referrals_buying_closed) {
        receiverDeclinedNum += question.previous_value.referrals_buying_closed
      }
      return receiverDeclinedNum
    },
    previous_receiver_referral_accepted () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let receiverAcceptedNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.previous_value || (!question.previous_value.receiver_referrals_selling_accepted && !question.previous_value.receiver_referrals_buying_accepted)) {
        return 'N/A'
      }
      if (question.previous_value && question.previous_value.receiver_referrals_selling_accepted) {
        receiverAcceptedNum += question.previous_value.referrals_selling_accepted
      }
      if (question.previous_value && question.previous_value.receiver_referrals_buying_accepted) {
        receiverAcceptedNum += question.previous_value.referrals_buying_accepted
      }
      return receiverAcceptedNum
    },
    current_receiver_referral_sent () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let receiverSentNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.result || (!question.result.receiver_referrals_selling_sent && !question.result.receiver_referrals_buying_sent)) {
        return 'N/A'
      }
      if (question.result && question.result.receiver_referrals_selling_sent) {
        receiverSentNum += question.result.receiver_referrals_selling_sent
      }
      if (question.result && question.result.receiver_referrals_buying_sent) {
        receiverSentNum += question.result.receiver_referrals_buying_sent
      }
      return receiverSentNum
    },
    current_receiver_referral_declined () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let receiverDeclinedNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.result || (!question.result.receiver_referrals_selling_closed && !question.result.receiver_referrals_buying_closed)) {
        return 'N/A'
      }
      if (question.result && question.result.receiver_referrals_selling_closed) {
        receiverDeclinedNum += question.result.receiver_referrals_selling_closed
      }
      if (question.result && question.result.receiver_referrals_buying_closed) {
        receiverDeclinedNum += question.result.receiver_referrals_buying_closed
      }
      return receiverDeclinedNum
    },
    current_receiver_referral_accepted () {
      if (!this.review.scorecard_flag) {
        return '-'
      }
      let receiverAcceptedNum = 0
      let question = this.form.questions[this.page][this.sectionStart][0]
      if (!question.result || (!question.result.receiver_referrals_selling_accepted && !question.result.receiver_referrals_buying_accepted)) {
        return 'N/A'
      }
      if (question.result && question.result.receiver_referrals_selling_accepted) {
        receiverAcceptedNum += question.result.receiver_referrals_selling_accepted
      }
      if (question.result && question.result.receiver_referrals_buying_accepted) {
        receiverAcceptedNum += question.result.receiver_referrals_buying_accepted
      }
      return receiverAcceptedNum
    }
  }
}
</script>
